
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from '../../../shared/Services/BaseService';
import { authenticationService } from '../../../shared/Services/authenticationService';
import { environment } from '../../../../../environments/environment';


@Injectable({
  providedIn: 'root',
})
export class FormsFieldService extends BaseService {

constructor( http: HttpClient, auth: authenticationService) {
  super(http, auth, environment.apiUrl + 'FormsFields');
 }

 getPhaseUsers(flgType: number) {
   return this.http.get<any[]>(environment.apiUrl + 'phase/getPhaseuser/' + flgType, {
    headers: this.headers,
  });
 }
}
